<!--
  2023/07/17 Effectively this now becomes a bread crumb bar with actions on the right hand side.
  All other "Global" functions and actions should remain in the main menu bar or a floating point action potentially.
  Design decision should be discussed with team.

  TODO FPA ALL ACTIONS TO A FPA ON MOBILE!
 -->

<!-- <div class="block md:hidden">
  <button
    style="position: fixed; bottom: 0px; right: 0px"
    pButton
    type="button"
    label="Open Menu"
    (click)="toggleMenu()"
  ></button>

  <p-sidebar [(visible)]="menuVisible" [fullScreen]="true">
    <h1 style="font-weight: normal">Full Screen Sidebar</h1>
    <p-button
      type="button"
      (click)="menuVisible = false"
      label="Save"
      styleClass="p-button-success mr-2"
    ></p-button>
    <p-button
      type="button"
      (click)="menuVisible = false"
      label="Cancel"
      styleClass="p-button-secondary mr-2"
    ></p-button>
  </p-sidebar>
</div> -->

<div
  class="layout-topbar linear-purple"
  *ngIf="items?.length || actions?.length"
  style="min-height: 50px; top: 33px"
>
  <div class="topbar-left" *ngIf="items?.length">
    <div class="flex flex-wrap">
      <div class="flex align-items-center justify-content-center">
        <ng-container *ngFor="let item of items">
          <div class="bm-breadcrumb mr-2">
            <ng-container *ngIf="item?.items; else singleUnit">
              <p-dropdown
                (onChange)="handleDropdown($event)"
                [options]="item.items"
                [placeholder]="item.label"
                optionLabel="label"
              ></p-dropdown>
            </ng-container>
            <ng-template #singleUnit>
              <ng-container *ngIf="item?.url">
                <a
                  [href]="item.url"
                  [routerLink]="[item.url]"
                  routerLinkActive="router-link-active"
                  [routerLinkActiveOptions]="{ exact: true }"
                >
                  {{ item.label }}
                </a>
              </ng-container>
              <ng-container *ngIf="!item?.url">
                {{ item.label }}
              </ng-container>
              <span><i class="pi pi-chevron-right"></i></span>
            </ng-template>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="topbar-right" *ngIf="actions?.length">
    <ul class="topbar-menu">
      <ng-container *ngFor="let action of actions">
        <ng-container *ngIf="action?.url">
          <li
            [href]="action.url"
            [ngClass]="action.class"
            [routerLink]="[action.url]"
            class="p-button p-button-outlined ml-1"
            routerLinkActive="router-link-active"
            [routerLinkActiveOptions]="{ exact: true }"
          >
            {{ action.label }}
          </li>
        </ng-container>

        <!-- TODO UPDATE THIS IT LOOKS MESSY USER ROUTER OUTLETS-->
        <ng-container *ngIf="action?.action">
          <ng-container *ngIf="action?.permissions; else noPermissionCheck">
            <ng-container
              *permissionChecker="{
                permissions: action.permissions,
                requirement: 'all'
              }"
            >
              <ng-container
                *ngIf="false; else noPermissionCheck"
              ></ng-container>
            </ng-container>
          </ng-container>
          <ng-template #noPermissionCheck>
            <li>
              <button
                (click)="action.action()"
                *ngIf="action.icon && !action.label"
                [icon]="action.icon"
                [ngClass]="action.class"
                class="p-button-outlined"
                iconPos="left"
                pButton
                type="button"
              ></button>

              <button
                (click)="action.action()"
                *ngIf="action.icon && action.label"
                [icon]="action.icon"
                [label]="action.label"
                [ngClass]="action.class"
                class="p-button-outlined"
                iconPos="left"
                pButton
                type="button"
              ></button>

              <button
                (click)="action.action()"
                *ngIf="!action.icon"
                [label]="action.label"
                [ngClass]="action.class"
                class="p-button-outlined"
                pButton
                type="button"
              ></button>
            </li>
          </ng-template>
        </ng-container>
      </ng-container>
    </ul>
  </div>
</div>
